// extracted by mini-css-extract-plugin
module.exports = {"Loader":"Spinner_Loader__2M8hj","load2":"Spinner_load2__1kYqg"};